import classnames from 'classnames'
import Article from 'entities/article'
import PropTypes from 'prop-types'
import React from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import { propTypeInstantiableTo } from 'supports/custom_prop_types'
import { IS_PC } from 'supports/user_agent_helper'
import { updateUrlQuery } from 'utilities/url_util'
import styles from './article_carousel.module.scss'

const SLIDES_TO_SHOW = 1

const slickSetting = slideCount => {
  const sliderOn = slideCount > SLIDES_TO_SHOW

  return {
    autoplay: sliderOn,
    autoplaySpeed: 5000,
    draggable: sliderOn,
    dots: sliderOn,
    dotsClass: styles.carouselPagination,
    infinite: sliderOn,
    speed: 500,
    slidesToShow: SLIDES_TO_SHOW,
    slidesToScroll: 1,
    swipe: sliderOn,
    swipeToSlide: sliderOn,
    arrows: IS_PC && sliderOn,
    nextArrow: IS_PC ? <NextArrow /> : null,
    prevArrow: IS_PC ? <PrevArrow /> : null,
    appendDots: dots => (
      <div>
        <ul className={styles.carouselPaginationDots}>{dots}</ul>
      </div>
    )
  }
}

const PrevArrow = ({ onClick }) => (
  <button type="button" className={classnames('btn', styles.btnCarousel, styles.btnPrev)} onClick={onClick}>
    <i className="ic-chevron-left" />
  </button>
)

PrevArrow.propTypes = {
  onClick: PropTypes.func
}

PrevArrow.defaultProps = {
  onClick: () => {}
}

const NextArrow = ({ onClick }) => (
  <button type="button" className={classnames('btn', styles.btnCarousel, styles.btnNext)} onClick={onClick}>
    <i className="ic-chevron-right" />
  </button>
)

NextArrow.propTypes = {
  onClick: PropTypes.func
}

NextArrow.defaultProps = {
  onClick: () => {}
}

const ArticleCarousel = ({ articles, cid }) => {
  const articlesCount = articles.length
  if (articlesCount === 0) {
    return null
  }

  const items = articles.map(article => {
    const { cover, id, title, url: articleUrl } = article
    const url = updateUrlQuery(articleUrl, 'cid', cid)

    return (
      <div key={id} className={styles.card}>
        <a className={styles.cardCover} href={url}>
          <div
            className={styles.cardCoverImage}
            style={{ backgroundImage: cover ? `url(${cover.thumb.url})` : null }}
          />
        </a>
        <div className={styles.cardInfos}>
          <h2 className={styles.cardTitle}>
            <a href={url}>{title}</a>
          </h2>
        </div>
      </div>
    )
  })

  return (
    <div className={styles.carousel}>
      <div className={styles.carouselInner}>
        {articlesCount === 1 ? items : <Slider {...slickSetting(articlesCount)}>{items}</Slider>}
      </div>
    </div>
  )
}

ArticleCarousel.propTypes = {
  articles: PropTypes.arrayOf(propTypeInstantiableTo(Article)).isRequired,
  cid: PropTypes.number
}

ArticleCarousel.defaultProps = {
  cid: null
}

export default ArticleCarousel
